import { render, staticRenderFns } from "./InputTypeBlood.vue?vue&type=template&id=63fe1d48&"
import script from "./InputTypeBlood.vue?vue&type=script&lang=js&"
export * from "./InputTypeBlood.vue?vue&type=script&lang=js&"
import style0 from "./InputTypeBlood.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports